var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProactiveAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.3909 18.0148C14.8197 19.6152 13.8699 21.2602 12.2695 21.689C10.6691 22.1178 9.02414 21.1681 8.59531 19.5677M10.8914 5.74085C11.1956 5.19355 11.2958 4.53205 11.121 3.87945C10.7636 2.54579 9.39275 1.75433 8.05909 2.11168C6.72542 2.46904 5.93397 3.83988 6.29132 5.17355C6.46619 5.82614 6.88372 6.34891 7.42082 6.67079M16.2358 9.44529C15.8788 8.11316 14.9259 6.99919 13.5866 6.34846C12.2474 5.69773 10.6314 5.56353 9.09437 5.97539C7.55729 6.38725 6.22496 7.31142 5.39048 8.54461C4.556 9.7778 4.28773 11.219 4.64467 12.5511C5.23524 14.7552 5.12057 16.5135 4.74761 17.8497C4.32255 19.3725 4.11001 20.134 4.16743 20.2869C4.23312 20.4618 4.28064 20.5098 4.45488 20.5773C4.60717 20.6363 5.24694 20.4649 6.52648 20.122L18.3915 16.9428C19.6711 16.6 20.3109 16.4285 20.4132 16.3013C20.5304 16.1557 20.5475 16.0904 20.517 15.906C20.4902 15.7449 19.9255 15.1918 18.7959 14.0855C17.8049 13.1148 16.8264 11.6493 16.2358 9.44529Z",
    stroke: "#145DD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProactiveAlert);
export default __webpack_public_path__ + "static/media/proactive-alert.b92bd6df31a3bf88094b1484441d40f9.svg";
export { ForwardRef as ReactComponent };